import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SortByAlphaIcon = (props: IconProps) => (
  <Icon w="18px" h="18px" viewBox="0 0 18 18" {...props}>
    <path d="M11.2052 3.49461H7.6652L9.43519 1.72461L11.2052 3.49461ZM7.6877 14.5271H11.1827L9.43519 16.2746L7.6877 14.5271ZM4.5752 4.70211L1.2002 13.2971H2.5802L3.2702 11.4596H7.1027L7.7927 13.2971H9.17269L5.8052 4.70211H4.5752ZM3.7277 10.2296L5.1827 6.34461L6.6377 10.2296H3.7277ZM11.7977 12.1046H16.3877V13.2971H9.99019V12.3296L14.4302 5.90961H10.0202V4.70961H16.2452V5.65461L11.7977 12.1046V12.1046Z" />
  </Icon>
);

export default memo(SortByAlphaIcon);
